import React from 'react';
import { Box, Button, Stack } from '@mui/material';
import { Typography } from "@mui/material";


const Header = ({displayAll=false}) => {



    return (
        <Box
            sx={{
                width: '100%',
                backgroundColor: 'white',
                // margin: '0 auto',
                // Your existing header styles...
                    position: 'sticky',
                    top: 0,
                    zIndex: 1000
            }}
        >
            <Box
                sx={{
                    pt: 3,
                    pb: 2,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 4,
                    width: '90%',
                    maxWidth: '1280px',
                    margin: '0 auto',
                    position: 'relative'
                }}
            >
                <Box
                    component="a"
                    href="https://picagroup.com.au/"
                    sx={{
                        cursor: 'pointer',
                        textDecoration: 'none',
                        
                    }}
                >
                    <img
                        src="/PICA_Logo_2023.png"
                        alt="PICA Logo"
                        aria-label="PICA Group Logo"
                    />
                </Box>
                {displayAll && <Box
                    component="a"
                    href="https://picagroup.com.au/forms-and-applications/"
                    sx={{
                        cursor: 'pointer',
                        textDecoration: 'none',
                    }}
                >
                    <Typography 
                        variant='h6' 
                        color='primary'
                        sx={{
                            position: 'relative',
                            '&:hover::after': {
                                content: '""',
                                position: 'absolute',
                                bottom: -8,
                                left: -10,
                                width: '108%',
                                height: '4px',
                                bgcolor: '#FFB81C'
                            }
                        }}
                    >
                        « Back to forms and applications
                    </Typography>
                </Box>
}
               
            </Box> 
        </Box>
    )
}

export default Header;

